import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Loader2 } from "lucide-react";

const API = "/api";

const AuthCallback = () => {
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const sessionId = window.location.hash.split("session_id=")[1]?.split("&")[0];
    axios
      .post(`${API}/auth/session`, {}, {
        headers: { "X-Session-ID": sessionId },
        withCredentials: true,
      })
      .then((res) => navigate("/admin", { state: { user: res.data }, replace: true }))
      .catch((err) => {
        const status = err.response?.status;
        const detail =
          status === 403
            ? "Esta cuenta de Google no tiene acceso al panel. Usá la cuenta autorizada."
            : "No pudimos iniciar sesión. Intentá de nuevo.";
        navigate("/admin", { state: { authError: detail }, replace: true });
      });
  }, [navigate]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-plum" data-testid="auth-callback">
      <Loader2 className="h-8 w-8 animate-spin text-magenta" />
    </div>
  );
};

export default AuthCallback;
